/**
 * Format file size in bytes to human readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + sizes[i];
};

/**
 * Get status color classes based on document status
 */
export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'Available':
      return 'text-green-600 bg-green-100';
    case 'Processing':
      return 'text-yellow-600 bg-yellow-100';
    case 'Failed':
      return 'text-red-600 bg-red-100';
    default:
      return 'text-gray-600 bg-gray-100';
  }
};

/**
 * Generate unique file ID
 */
export const generateFileId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Generate batch ID for dataset creation
 */
export const generateBatchId = (): string => {
  return new Date().toISOString().replace(/[-:T.]/g, '').slice(0, 17);
};

/**
 * Simulate API delay for development
 */
export const simulateApiDelay = (ms: number = 1000): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

/**
 * Truncate text to specified length
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

/**
 * Filter knowledge items based on search text
 */
export const filterKnowledgeItems = <T extends { name: string; description: string; tags?: string[] }>(
  items: T[],
  searchText: string
): T[] => {
  if (!searchText.trim()) return items;

  const searchLower = searchText.toLowerCase();
  return items.filter(item =>
    item.name.toLowerCase().includes(searchLower) ||
    item.description.toLowerCase().includes(searchLower) ||
    (item.tags && item.tags.some(tag => tag.toLowerCase().includes(searchLower)))
  );
};
